import React, { Fragment } from "react";
import {
  Route,
  Link,
  useRouteMatch,
  useLocation,
} from "react-router-dom";
import { createBrowserHistory } from "history";

import { withStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Releasenote from "../components/Releasenote";

const styles = (theme) => ({
  aboveDrawer: {
    zIndex: theme.zIndex.drawer + 1,
  },
  backButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  versionCode: {
    fontWeight: 100,
    textAligin: "right",
  },
});

const history = createBrowserHistory();
// console.log("history: ", history);

const Setting = ({ classes }, props) => {
  const [open, setOpen] = React.useState(false);
  let match = useRouteMatch();
  //console.log("match: ", match);

  let location = useLocation();
  //console.log('location: ', location);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    if (
      location.pathname === "/設定/利用規約" ||
      location.pathname === "/設定/リリースノート"
    ) {
      //console.log('history sitai')
      //history.goBack();
    }
  };

  const AlertDialog = () => {
    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>最新版をご利用中です</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleUpdate = async () => {
    const registration = await navigator.serviceWorker.getRegistration();
    registration.update();

    if (!!registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
      window.location.reload();
    } else {
      handleClickOpen();
    }
  };

  return (
    <Fragment>
      <List>
        <Link to={location.pathname === match.url ? `${match.url}/リリースノート` : (location.pathname === `${match.url}/リリースノート` ? match.url : `${match.url}/リリースノート`)}>
          <ListItem button onClick={handleClick} divider>
            <ListItemText>バージョン</ListItemText>
            <span className={classes.versionCode}>
              <ListItemText>1.0.1</ListItemText>
            </span>
          </ListItem>
        </Link>
        <ListItem button onClick={() => { history.push(`/チュートリアル`); window.location.reload(); }} divider>
          <ListItemText>チュートリアル</ListItemText>
        </ListItem>
        <ListItem button onClick={handleUpdate} divider>
          <ListItemText>アプリを更新</ListItemText>
        </ListItem>
        {open && <AlertDialog />}
        <ListItem button onClick={() => window.open("https://terms-213ad.web.app/", "_blank")} divider>
          <ListItemText>利用規約</ListItemText>
        </ListItem>
        <ListItem button onClick={() => window.open("https://privacypolicy-bb1c0.web.app/", "_blank")} divider>
          <ListItemText>プライバシーポリシー</ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText> </ListItemText>
        </ListItem>
      </List>
      <main className={classes.content}>
        <Route path={`${match.path}/リリースノート`} component={Releasenote} />
        {/* <Route path={`${match.path}/利用規約`} component={Terms} /> */}
      </main>
    </Fragment>
  );
};

export default withStyles(styles)(Setting);